import {BaseModel} from "../../models/base-model";
import {LOG_TYPES} from "../../../core/consts";

export class LogModel extends BaseModel {
  type: LOG_TYPES;
  title: String;
  context: String;
  args: Array<String>;

  constructor(type: LOG_TYPES, title: String, context: String, args: Array<String>) {
    super();

    this.type = type;
    this.title = title;
    this.context = context;
    this.args = args;
  }

  equals(model: LogModel): * {
    let equals = true;

    equals &= this.type === model.type;
    equals &= this.title === model.title;
    equals &= this.context === model.context;

    return equals;
  }
}
